import { Component, OnInit, Pipe, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute} from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ApiService } from 'src/@sbt/services/api.service';
import { UtilService } from 'src/@sbt/utils/util.service';

import { SwiperOptions } from 'swiper';
import SwiperCore, { Pagination, Navigation, Autoplay, EffectFade } from 'swiper';

import { DomSanitizer } from "@angular/platform-browser";

@Pipe({
  name: 'safeHtml',
})

@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
})


export class LoginPage implements OnInit {

  page = 'LOGIN';

  // UI CONTROL
  disabledButton = true;
  isChecked = false;

  // Form and Data Control
  projectId: string;
  sbtForm: FormGroup;
  sbtForm2: FormGroup;
  appProject: any = {};
  backgroundJson: any = {};
  infoData: any;
  pictureJson: any;
  errorMessage: string;
  showCard: boolean = false;
  showTermsCard: boolean = false;
  cardInfo: string = '';
  tenantInfo: string = '';
  tenantAddress: string = '';
  tenantEmail: string = '';
  tenantPhone: string = '';
  tenantFax: string = '';
  tenantWebsite: string = '';

  // Other Control
  routeParam: any;
  destroy$: Subject<boolean> = new Subject<boolean>();

  //Swiper
  config: SwiperOptions = {
    slidesPerView: 'auto',
    spaceBetween: 50,
    pagination: {
      dynamicBullets: true
    },
    navigation: true
  }

  config2: SwiperOptions = {
    slidesPerView: 'auto',
    spaceBetween: 50,
    pagination: {
      dynamicBullets: true
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    }
  }

  constructor(
    private api: ApiService,
    private util: UtilService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private sanitizer: DomSanitizer
  ) {
    this.sbtForm = this.fb.group({});
    this.sbtForm2 = this.fb.group({});
    SwiperCore.use([Pagination, Navigation, Autoplay, EffectFade]);
  }

  ngOnInit() {
    this.errorMessage = '';
    this.routeParam = this.route.params.subscribe(params => {
      if (params) {
        this.projectId = params['id'];
        this.api.httpGetSecurity(`eclatlogin/${this.projectId}`).pipe(takeUntil(this.destroy$)).subscribe(data => {
          this.appProject = data[0];
          if (this.appProject) {

            this.backgroundJson = this.appProject.BackgroundJson;
            console.log(this.backgroundJson)

            if (this.appProject.SerialNumberInNineteen) {
              this.sbtForm = this.fb.group({
                ProjectId: [this.appProject.Id],
                SerialNumber1: [null, (this.appProject.Particular19)? Validators.required : ''],
                SerialNumber2: [null, (this.appProject.SerialNumber2)? Validators.required : ''],
                SerialNumber3: [null, (this.appProject.SerialNumber3)? Validators.required : ''],
                Id1: [null, (this.appProject.Id1)? Validators.required : ''],
                Id2: [null, (this.appProject.Id2)? Validators.required : ''],
                Id3: [null, (this.appProject.Id3)? Validators.required : ''],    
              });
            }
            else {
              this.sbtForm = this.fb.group({
                ProjectId: [this.appProject.Id],
                SerialNumber1: [null, (this.appProject.SerialNumber1)? Validators.required : ''],
                SerialNumber2: [null, (this.appProject.SerialNumber2)? Validators.required : ''],
                SerialNumber3: [null, (this.appProject.SerialNumber3)? Validators.required : ''],
                Id1: [null, (this.appProject.Id1)? Validators.required : ''],
                Id2: [null, (this.appProject.Id2)? Validators.required : ''],
                Id3: [null, (this.appProject.Id3)? Validators.required : ''],    
              });
            }
          }
          
          if (this.appProject) {
            this.tenantInfo = this.appProject.FooterDetail[0].Info;
            this.tenantEmail = this.appProject.FooterDetail[0].Email;
            this.tenantPhone = this.appProject.FooterDetail[0].Phone;
            this.tenantFax = this.appProject.FooterDetail[0].Fax;
            this.tenantWebsite = this.appProject.FooterDetail[0].Website;
          }
        });
      }
    });
  }

  ngOnDestroy() {
    this.routeParam.unsubscribe();
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  transform(html) {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  //Usually use for Validations
  button1() {
    this.api.httpPostSecurity('eclatauthenticate', this.sbtForm.getRawValue()).pipe(takeUntil(this.destroy$)).subscribe(data => {
      if (data.length === 0) {
        this.util.genericMessageBox('Alert', 'Inputted combinations does not match with our system.\n Please check again.');
        this.sbtForm.reset();
        this.sbtForm.get('ProjectId').setValue(this.appProject.Id);

        this.isChecked = false;
        return;
      }
      else {
        this.infoData = data[0];
        this.sbtForm2 = this.fb.group({
          Id1: [null, (data[0].Id1)? Validators.required : ''],
          Id2: [null, (data[0].Id2)? Validators.required : ''],
          Id3: [null, (data[0].Id3)? Validators.required : ''],
          SerialNumber1: [null, (data[0].SerialNumber1)? Validators.required : ''],
          SerialNumber2: [null, (data[0].SerialNumber2)? Validators.required : ''],
          SerialNumber3: [null, (data[0].SerialNumber3)? Validators.required : ''],
          Name1: [null, (data[0].Name1)? Validators.required : ''],
          Name2: [null, (data[0].Name2)? Validators.required : ''],
          Name3: [null, (data[0].Name3)? Validators.required : ''],
          IssueDate: [null, (data[0].IssueDate)? Validators.required : ''],
          ExpireDate: [null, (data[0].ExpireDate)? Validators.required : ''],
          PrintDate: [null, (data[0].PrintDate)? Validators.required : ''],
          Particular01: [null, (data[0].Particular01)? Validators.required : ''],
          Particular02: [null, (data[0].Particular02)? Validators.required : ''],
          Particular03: [null, (data[0].Particular03)? Validators.required : ''],
          Particular04: [null, (data[0].Particular04)? Validators.required : ''],
          Particular05: [null, (data[0].Particular05)? Validators.required : ''],
          Particular06: [null, (data[0].Particular06)? Validators.required : ''],
          Particular07: [null, (data[0].Particular07)? Validators.required : ''],
          Particular08: [null, (data[0].Particular08)? Validators.required : ''],
          Particular09: [null, (data[0].Particular09)? Validators.required : ''],
          Particular10: [null, (data[0].Particular10)? Validators.required : ''],
          Particular11: [null, (data[0].Particular11)? Validators.required : ''],
          Particular12: [null, (data[0].Particular12)? Validators.required : ''],
          Particular13: [null, (data[0].Particular13)? Validators.required : ''],
          Particular14: [null, (data[0].Particular14)? Validators.required : ''],
          Particular15: [null, (data[0].Particular15)? Validators.required : ''],
          Particular16: [null, (data[0].Particular16)? Validators.required : ''],
          Particular17: [null, (data[0].Particular17)? Validators.required : ''],
          Particular18: [null, (data[0].Particular18)? Validators.required : ''],
          Particular19: [null, (data[0].Particular19)? Validators.required : ''],
          Particular20: [null, (data[0].Particular20)? Validators.required : ''],
          Number01: [null, (data[0].Number01)? Validators.required : ''],
          Number02: [null, (data[0].Number02)? Validators.required : ''],
          Number03: [null, (data[0].Number03)? Validators.required : ''],
          Number04: [null, (data[0].Number04)? Validators.required : ''],
          Number05: [null, (data[0].Number05)? Validators.required : ''],
          Number06: [null, (data[0].Number06)? Validators.required : ''],
          Number07: [null, (data[0].Number07)? Validators.required : ''],
          Number08: [null, (data[0].Number08)? Validators.required : ''],
          Number09: [null, (data[0].Number09)? Validators.required : ''],
          Number10: [null, (data[0].Number10)? Validators.required : ''],
          Date01: [null, (data[0].Date01)? Validators.required : ''],
          Date02: [null, (data[0].Date02)? Validators.required : ''],
          Date03: [null, (data[0].Date03)? Validators.required : ''],
          Date04: [null, (data[0].Date04)? Validators.required : ''],
          Date05: [null, (data[0].Date05)? Validators.required : ''],
          Status: [null],
          PublishExpireDate: [null],
          PictureJson: [null]
        });
        
        this.sbtForm2.setValue(data[0]);

        if (this.sbtForm2.get('Status').value != 70) {
          this.errorMessage = 'This project has not been published!';
          return;
        }
        
        let today = new Date();
        let publishExpireDate = new Date(this.sbtForm2.get('PublishExpireDate').value);

        if (publishExpireDate < today) {
          this.errorMessage = 'Online validation function has expired!';
          return;
        }

        this.pictureJson = data[0].PictureJson;
        
        setTimeout(() => {
          this.page = 'INFO';
        });
      }
    });
  }

  checkboxChange(e) {
    let value = e.detail.checked;
    if (value && this.sbtForm.valid) {
      this.disabledButton = false;
      this.isChecked = true;
      return;
    }

    this.disabledButton = true;
    this.isChecked = false;
  }

  termsController(expandOnly: boolean) {
    if (expandOnly) {
      this.showTermsCard = true;
    }
    else {
      this.showTermsCard = false;
    }
  }

  modalController(expandOnly: boolean){
    if (expandOnly) {
      this.showCard = true;
    }
    else {
      this.showCard = false;
    }
  }
}
